import { useState, useContext } from 'react';
import AuthContext from './AuthContext'; // Importación por defecto

const LoginForm = ({ onLoginSuccess, onBack }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(username, password)) {
      onLoginSuccess();
    } else {
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-2xl p-8 border border-gray-200">
        <div className="flex justify-center mb-6">
          <img 
            src="/logo-elede.png" 
            alt="ELEDÉ Logo"
            className="h-16"
          />
        </div>
        <h2 className="text-[#060D14] text-3xl font-extrabold text-center mb-8">Acceso Administrador</h2>
        {error && <p className="text-red-600 bg-red-50 p-3 rounded-lg mb-6 text-center border border-red-200">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#961914] focus:border-transparent transition duration-200"
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#961914] focus:border-transparent transition duration-200"
              required
            />
          </div>
          <div className="flex space-x-4 mt-8">
            <button
              type="button"
              onClick={onBack}
              className="flex-1 bg-gray-200 text-gray-800 py-3 rounded-lg font-semibold hover:bg-gray-300 transition duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
              Volver
            </button>
            <button
              type="submit"
              className="flex-1 bg-[#961914] text-white py-3 rounded-lg font-semibold hover:bg-[#7a140f] transition duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-[#961914]"
            >
              Ingresar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;